/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {BehaviorTrackerState} from './behavior-tracker.reducer';

// Selector functions
const behaviorTrackerData =
  createFeatureSelector<BehaviorTrackerState>('ss-cord.behavior-tracker');

// Get Side Nav Weeks List
export const sideNavWeeksList = createSelector(
  behaviorTrackerData,
  (state: BehaviorTrackerState) => state.sideNavWeeksList
);

// Get Weeks List
export const weekListInfo = createSelector(
  behaviorTrackerData,
  (state: BehaviorTrackerState) => state.weekListInfo
);

// Get Resource List
export const resourceList = createSelector(
  behaviorTrackerData,
  (state: BehaviorTrackerState) => state.resourceList
);

// Get Week Summary
export const weekSummary = createSelector(
  behaviorTrackerData,
  (state: BehaviorTrackerState) => state.summary
);

export const groupInfo = createSelector(
  behaviorTrackerData,
  (state: BehaviorTrackerState) => state.groupInfo
);

export const dailyScoreInfo = createSelector(
  behaviorTrackerData,
  (state: BehaviorTrackerState) => state.dailyScoreInfo
);
